<div class="content-container bg-white">
    <h1 translate>
        {{
            editingMyProfile ? 'users.form.actions.titleModifyMyProfile' :
                !!customerId ? 'users.form.actions.titleModify' : 'users.form.actions.titleCreate'
        }}
    </h1>

    @if (!editingMyProfile) {
        <div [appHasAnyPermission]="[PermissionKeys.gestionClients]">
            <div class="btn-bar">
                <button class="btn btn-outline-secondary" type="button"
                        (click)="back()"
                        translate="common.back">
                </button>
                @if (customerId) {
                    <button class="btn btn-outline-danger"
                            (click)="deleteCustomer()"
                            translate="common.delete">
                    </button>
                }
            </div>
        </div>
    }

    <form [formGroup]="customerForm" class="mt-4">
        @if (customerId) {
            <div>
                <p><em translate="users.form.reallocation-warning"></em></p>
            </div>
        }

        <!-- ETIQUETTE -->
        <div class="row">
            <div class="col-12">
                <label class="form-label">{{ 'users.form.title.label' | translate }}*</label>

                <div class="form-check">
                    <input class="form-check-input" type="radio" id="Madam" name="title"
                           value="Madam"
                           [formControl]="title">
                    <label class="form-check-label" for="Madam"
                           translate="users.form.title.madam"></label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" id="Mister" name="title"
                           value="Mister"
                           [formControl]="title">
                    <label class="form-check-label" for="Mister"
                           translate="users.form.title.mister"></label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" id="notSpecified" name="title"
                           value="NotSpecified"
                           [formControl]="title">
                    <label class="form-check-label" for="notSpecified"
                           translate="users.form.title.notspecified"></label>
                </div>
                <app-form-error [control]="title"></app-form-error>
            </div>

            <!-- CustomerId -->
            @if (customerId) {
                <div class="col-12 col-lg-6">
                    <label class="form-label" for="customerId">{{ 'users.form.customerId' | translate }}</label>
                    <input class="form-control" id="customerId" type="text"
                           [formControl]="id" disabled>
                </div>
            }

            <!-- AccountEnabled -->
            @if (!editingMyProfile) {
                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'users.form.accountEnabled.label' | translate }}*</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" id="accountEnabled" type="checkbox" name="accountEnabled"
                               [formControl]="accountEnabled">
                        <label class="form-check-label" for="accountEnabled">
                            {{ (accountEnabled.value ? 'users.form.accountEnabled.true' : 'users.form.accountEnabled.false') | translate }}
                        </label>
                    </div>
                    <app-form-error [control]="accountEnabled"></app-form-error>
                </div>
            }

            <!-- firstname -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="firstname">{{ 'users.form.firstname' | translate }}*</label>
                <input class="form-control" id="firstname" type="text" maxlength="50"
                       placeholder="{{ 'users.form.firstname' | translate }}"
                       [formControl]="firstname"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="firstname"></app-form-error>
            </div>

            <!-- lastname -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="lastname">{{ 'users.form.lastname' | translate }}*</label>
                <input class="form-control " id="lastname" type="text" maxlength="50"
                       placeholder="{{ 'users.form.lastname' | translate }}"
                       [formControl]="lastname"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="lastname"></app-form-error>
            </div>

            <!-- birthDate -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="birthDate" translate="users.form.birthDate"></label>
                <div class="input-group">
                    <input class="form-control" placeholder="{{ 'common.placeholders.dateFormat' | translate}}"
                           id="birthDate"
                           [formControl]="birthDate"
                           ngbDatepicker
                           #dpBirthDate="ngbDatepicker">
                    <div class="input-group-append">
                        <button class="btn btn-link btn-sm" (click)="dpBirthDate.toggle()">
                            <fa-icon [icon]="icons.calendar"></fa-icon>
                        </button>
                        @if (!!birthDate.value) {
                            <button class="btn btn-link btn-sm"
                                    (click)="birthDate.setValue(null)">
                                <fa-icon [icon]="icons.times"></fa-icon>
                            </button>
                        }
                    </div>
                </div>
                <app-form-error [control]="birthDate"></app-form-error>
            </div>

            <!-- email -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="email">{{ 'users.form.email' | translate }}*</label>
                <input class="form-control " id="email" type="text" maxlength="75"
                       placeholder="{{ 'users.form.email' | translate }}"
                       [formControl]="email"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="email"></app-form-error>
            </div>

            @if (!editingMyProfile) {
                <!-- CustomerNumber -->
                <div class="col-12 col-lg-6">
                    <label class="form-label"
                           for="customerNumber">{{ 'users.form.customerNumber' | translate }}*</label>
                    <input class="form-control" id="customerNumber" type="text" maxlength="25"
                           placeholder="{{ 'users.form.customerNumber' | translate }}"
                           [formControl]="customerNumber"
                           pattern="{{textInputPattern}}">
                    <app-form-error [control]="customerNumber"></app-form-error>
                </div>

                <!-- AttentionTo -->
                <div class="col-12 col-lg-6">
                    <label class="form-label" for="attentionTo">{{ 'users.form.attentionTo' | translate }}</label>
                    <input class="form-control" id="attentionTo" type="text" maxlength="50"
                           placeholder="{{ 'users.form.attentionTo' | translate }}"
                           [formControl]="attentionTo"
                           pattern="{{textInputPattern}}">
                    <app-form-error [control]="attentionTo"></app-form-error>
                </div>

                @if (householdSizeDisplayed) {
                    <!-- HouseholdSize -->
                    <div class="col-12 col-lg-6">
                        <label class="form-label"
                               for="householdSize">{{ 'users.form.householdSize' | translate }}*</label>
                        <input class="form-control" id="householdSize" type="number" min="1" step="1"
                               placeholder="{{ 'users.form.householdSize' | translate }}"
                               [formControl]="householdSize">
                        <app-form-error [control]="householdSize"></app-form-error>
                    </div>
                }
            }

            <!-- street -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="street">{{ 'users.form.street' | translate }}*</label>
                <input class="form-control " id="street" type="text" maxlength="50"
                       placeholder="{{ 'users.form.street' | translate }}"
                       [formControl]="street"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="street"></app-form-error>
            </div>

            <!-- postalCode -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="postalCode">{{ 'users.form.postalCode' | translate }}*</label>
                <input class="form-control " id="postalCode" type="text" maxlength="10"
                       placeholder="{{ 'users.form.postalCode' | translate }}"
                       [formControl]="postalCode"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="postalCode"></app-form-error>
            </div>

            <!-- city -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="city">{{ 'users.form.city' | translate }}*</label>
                <input class="form-control " id="city" type="text" maxlength="25"
                       placeholder="{{ 'users.form.city' | translate }}"
                       [formControl]="city"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="city"></app-form-error>
            </div>

            <!-- country -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="country">{{ 'users.form.country' | translate }}*</label>
                <input class="form-control " id="country" type="text" maxlength="25"
                       placeholder="{{ 'users.form.country' | translate }}"
                       [formControl]="country"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="country"></app-form-error>
            </div>

            <!-- phoneNumbers -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="phone" translate="users.form.phone"></label>
                <input class="form-control " id="phone" type="tel" maxlength="16"
                       placeholder="{{ 'common.placeholders.phone' | translate }}"
                       [formControl]="phone">
            </div>
            <div class="col-12 col-lg-6">
                <label class="form-label" for="mobilePhone" translate="users.form.mobilePhone"></label>
                <input class="form-control " id="mobilePhone" type="tel" maxlength="16"
                       placeholder="{{ 'common.placeholders.phone' | translate }}"
                       [formControl]="mobilePhone">
            </div>
            <div class="col-12 col-lg-6">
                <label class="form-label" for="businessPhone" translate="users.form.businessPhone"></label>
                <input class="form-control " id="businessPhone" type="tel" maxlength="16"
                       placeholder="{{ 'common.placeholders.phone' | translate }}"
                       [formControl]="businessPhone">
            </div>
        </div>

        @if (!editingMyProfile) {
            <div class="row">
                <app-custom-role-management class="col-12 col-sm-6"
                                            formControlName="customRoles"></app-custom-role-management>
                <app-site-assignment class="col-12 col-sm-6"
                                     formControlName="sites"></app-site-assignment>
            </div>
        }

        @if (!editingMyProfile && this.ewallet) {
            <div
                [appHasAnyPermission]="[PermissionKeys.gestionTransactions]">
                <h4 class="mt-4" translate="users.ewallet"></h4>
                <table class="table table-striped mb-5"
                       aria-label="{{ 'users.ewallet' | translate }}">
                    <thead>
                    <tr>
                        <th scope="col" translate="ewallet.table.balance"></th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{ this.ewallet.balance | currencyFormat }}</td>
                        <td class="text-end">
                            <button class="btn btn-link btn-sm" type="button"
                                    title="{{'common.tooltip.open' | translate}}"
                                    [routerLink]="['/ewallet', this.customerId]">
                                <fa-icon [icon]="icons.wallet"></fa-icon>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        }

        @if (editingMyProfile) {
            <h4 class="mt-4">{{ 'Sites' | translate }}</h4>

            <table class="table table-striped mb-5"
                   [attr.aria-label]="'Sites' | translate">
                <thead>
                <tr>
                    <th scope="col">{{ 'Nom' | translate }}</th>
                    <th scope="col">{{ 'Description' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                    @for (site of sites.value; track site.id) {
                        <tr>
                            <td>{{ siteName(site) }}</td>
                            <td>{{ siteDescription(site) }}</td>
                        </tr>
                    } @empty {
                        <tr>
                            <td>{{ 'AucunSite' | translate }}</td>
                            <td></td>
                        </tr>
                    }
                </tbody>
            </table>
        }

        <h4 class="mt-4">{{ 'users.card.cards' | translate }}</h4>

        <!-- RFID Cards -->
        @if (!editingMyProfile) {
            <div class="btn-bar" [appHasAnyPermission]="[PermissionKeys.exploitationCartes]">
                <button class="btn btn-primary" type="button"
                        (click)="addRfidCard()"
                        translate="users.card.add"></button>
            </div>
        }

        <table class="table table-striped mb-5"
               [attr.aria-label]="'users.card.cards' | translate">
            <thead>
            <tr>
                <th scope="col" translate="cards.table.cardNumber"></th>
                <th scope="col" translate="cards.table.uid"></th>
                <th scope="col" translate="cards.table.status"></th>
                <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
                @if (cards.length === 0) {
                    <tr>
                        <td>-</td>
                        <td>-</td>
                        <td></td>
                        <td></td>
                    </tr>
                }

                @for (card of cards; track card) {
                    <tr>
                        <td> {{ card.cardNumber }}</td>
                        <td> {{ card.uid }}</td>
                        <td> {{
                                !editingMyProfile && !customerId
                                    ? ('cards.status.assigned' | translate)
                                    : ('cards.status.' + card.cardState.toLowerCase() | translate)
                            }}
                        </td>
                        <td class="text-end">
                            @if (!editingMyProfile) {
                                <div [appHasAnyPermission]="[PermissionKeys.exploitationCartes]">
                                    @if (!isVirtualCard(card)) {
                                        <button class="btn btn-link btn-sm"
                                                type="button"
                                                (click)="unassignRfidCard(card)"
                                                title="{{'common.tooltip.unassignRfidCard' | translate}}">
                                            <fa-icon [icon]="icons.userSlash"></fa-icon>
                                        </button>
                                    }

                                    @if (!isVirtualCard(card)) {
                                        <button class="btn btn-link btn-sm"
                                                type="button"
                                                (click)="updateRfidCard(card)"
                                                title="{{'common.tooltip.edit' | translate}}">
                                            <fa-icon [icon]="icons.edit"></fa-icon>
                                        </button>
                                    }
                                </div>
                            }

                            @if (isVirtualCard(card) && !editingMyProfile) {
                                <div [appHasAnyPermission]="[PermissionKeys.exploitationCartes]">
                                    <button class="btn btn-link btn-sm"
                                            type="button"
                                            (click)="openVirtualCardQrCode()"
                                            title="{{'common.tooltip.open' | translate}}">
                                        <fa-icon [icon]="icons.qrCode"></fa-icon>
                                    </button>
                                    <button class="btn btn-link btn-sm"
                                            type="button"
                                            (click)="regenerateVirtualCard()"
                                            title="{{'common.tooltip.regenerate' | translate}}">
                                        <fa-icon [icon]="icons.generate"></fa-icon>
                                    </button>
                                </div>
                            }

                            @if (isVirtualCard(card) && editingMyProfile) {
                                <div>
                                    <button class="btn btn-link btn-sm"
                                            type="button"
                                            (click)="openVirtualCardQrCode()"
                                            title="{{'common.tooltip.open' | translate}}">
                                        <fa-icon [icon]="icons.qrCode"></fa-icon>
                                    </button>
                                    <button class="btn btn-link btn-sm"
                                            type="button"
                                            (click)="regenerateVirtualCard()"
                                            title="{{'common.tooltip.regenerate' | translate}}">
                                        <fa-icon [icon]="icons.generate"></fa-icon>
                                    </button>
                                </div>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>

        @if (!editingMyProfile) {
            <div class="text-center">
                <p><em translate="user-creation.form.message.rgpd_warning"></em></p>
            </div>

            <div class="row">
                <!-- Comment -->
                <div class="col-12 col-lg-6">
                    <label class="form-label" for="comment" translate="users.form.comment"></label>
                    <textarea class="form-control" id="comment" name="comment"
                              maxlength="255"
                              [formControl]="comment"
                              placeholder="{{ 'users.form.comment' | translate }}"></textarea>
                </div>

                <!-- internalField1 -->
                <div class="col-12 col-lg-6">
                    <label class="form-label" for="internalField1" translate="users.form.internalField1"></label>
                    <textarea id="internalField1" name="internalField1" class="form-control"
                              maxlength="255"
                              [formControl]="internalField1"
                              placeholder="{{ 'users.form.internalField1' | translate }}"></textarea>
                </div>

                @if (!editingMyProfile) {
                    <!-- internalField2 -->
                    <div class="col-12 col-lg-6">
                        <label class="form-label" for="internalField2" translate="users.form.internalField2"></label>
                        <textarea id="internalField2" name="internalField2" class="form-control"
                                  maxlength="255"
                                  [formControl]="internalField2"
                                  placeholder="{{ 'users.form.internalField2' | translate }}"></textarea>
                    </div>

                    <!-- internalField3 -->
                    <div class="col-12 col-lg-6">
                        <label class="form-label" for="internalField3" translate="users.form.internalField3"></label>
                        <textarea id="internalField3" name="internalField3" class="form-control"
                                  maxlength="255"
                                  [formControl]="internalField3"
                                  placeholder="{{ 'users.form.internalField3' | translate }}"></textarea>
                    </div>

                    <!-- internalField4 -->
                    <div class="col-12 col-lg-6">
                        <label class="form-label" for="internalField4" translate="users.form.internalField4"></label>
                        <textarea id="internalField4" name="internalField4" class="form-control"
                                  maxlength="255"
                                  [formControl]="internalField4"
                                  placeholder="{{ 'users.form.internalField4' | translate }}"></textarea>
                    </div>

                    <!-- internalField5 -->
                    <div class="col-12 col-lg-6">
                        <label class="form-label" for="internalField5" translate="users.form.internalField5"></label>
                        <textarea id="internalField5" name="internalField5" class="form-control"
                                  maxlength="255"
                                  [formControl]="internalField5"
                                  placeholder="{{ 'users.form.internalField5' | translate }}"></textarea>
                    </div>
                }
            </div>
        }

        @if (customerId) {
            <div ngbAccordion [appHasAnyPermission]="[PermissionKeys.gestionClients]"
                 class="mt-4"
                 (show)="fetchAudits()">
                <div ngbAccordionItem>
                    <h2 ngbAccordionHeader>
                        <button ngbAccordionButton translate="users.history.title"></button>
                    </h2>

                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                @if (!!pagedAudits) {
                                    <ngx-datatable
                                        class="material"
                                        [columnMode]="'force'"
                                        [rows]="pagedAudits.results"
                                        [headerHeight]="50"
                                        [footerHeight]="50"
                                        [rowHeight]="'auto'"
                                        [externalPaging]="true"
                                        [externalSorting]="true"
                                        [count]="pagedAudits.rowCount"
                                        [messages]="{
                                            totalMessage: 'common.datatable.total' | translate
                                        }"
                                        [offset]="auditCurrentPage"
                                        [limit]="auditPageSize"
                                        (page)="setAuditsPage($event)"
                                        [scrollbarH]="true"
                                        [rowClass]="getRowClass">

                                        <!-- Date -->
                                        <ngx-datatable-column [width]="150" [sortable]="false" name="{{ 'common.date.date' | translate }}">
                                            <ng-template ngx-datatable-cell-template let-audit="row">
                                                {{ audit.modificationDate | date:dateTimeFormat }}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <!-- Modification user -->
                                        <ngx-datatable-column [width]="300" [sortable]="false"
                                                              name="{{ 'users.history.author' | translate }}">
                                            <ng-template ngx-datatable-cell-template let-audit="row">
                                                {{ audit.modificationUser }}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <!-- Modifications -->
                                        <ngx-datatable-column [width]="600" [sortable]="false"
                                                              name="{{ 'users.history.modifications' | translate }}">
                                            <ng-template ngx-datatable-cell-template let-audit="row">
                                                <!-- Basic entity properties change -->
                                                @if (audit.changeType === CustomerAuditEntryPropertyChangeType.PropertyChange) {
                                                    <div>
                                                        @for (change of audit.properties; track change) {
                                                            <div>
                                                                @if (change.propertyName === 'Title') {
                                                                    <strong>{{ 'users.history.fields.' + change.propertyName | translate }}</strong>
                                                                    :
                                                                    {{ 'users.form.title.' + change.oldValue.toLowerCase() | translate }}
                                                                    ->
                                                                    {{ 'users.form.title.' + change.newValue.toLowerCase() | translate }}
                                                                } @else {
                                                                    @if (change.propertyName === 'AccountEnabled') {
                                                                        @if (change.newValue === 'True') {
                                                                            <div>
                                                                                {{ 'users.history.accountActivation' | translate }}
                                                                            </div>
                                                                        } @else {
                                                                            <div>
                                                                                {{ 'users.history.accountDeactivation' | translate }}
                                                                            </div>
                                                                        }
                                                                    } @else {
                                                                        <strong>{{ 'users.history.fields.' + change.propertyName | translate }}</strong>
                                                                        :
                                                                        {{ change.oldValue }}
                                                                        ->
                                                                        {{ change.newValue }}
                                                                    }
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                @switch (audit.changeType) {
                                                    @case (CustomerAuditEntryPropertyChangeType.UserCreation) {
                                                        <div>
                                                            {{ 'users.history.customerCreation' | translate }}
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.RoleAssignment) {
                                                        <div>
                                                            {{ 'users.history.roleAssignment' | translate }}
                                                            <i>{{ audit['roleLabel' + crtLang.toUpperCase()] }}</i>
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.RoleUnassignment) {
                                                        <div>
                                                            {{ 'users.history.roleUnassignment' | translate }}
                                                            <i>{{ audit['roleLabel' + crtLang.toUpperCase()] }}</i>
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.RfidCardAssignment) {
                                                        <div>
                                                            {{ 'users.history.rfidCardAssignment' | translate }}
                                                            <i>{{ audit.rfidCardUid }}</i>
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.RfidCardUnassignment) {
                                                        <div>
                                                            {{ 'users.history.rfidCardUnassignment' | translate }}
                                                            <i>{{ audit.rfidCardUid }}</i>
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.RfidCardStateChange) {
                                                        <div>
                                                            {{ 'users.history.rfidCardStateChange' | translate }}
                                                            <i>{{ audit.rfidCardUid }}</i>
                                                            : {{ 'cards.status.' + audit.properties[0].oldValue.toLowerCase() | translate }}
                                                            -> {{ 'cards.status.' + audit.properties[0].newValue.toLowerCase() | translate }}
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.VirtualCardRenewal) {
                                                        <div>
                                                            {{ 'users.history.virtualCardRenewal' | translate }}
                                                            : <i>{{ audit.properties[0]?.oldValue }}</i>
                                                            -> <i>{{ audit.rfidCardUid }}</i>
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.SiteAssignment) {
                                                        <div>
                                                            {{ 'users.history.siteAssignment' | translate }}
                                                            <i>{{ audit['siteName' + crtLang.toUpperCase()] }}</i>
                                                        </div>
                                                    }
                                                    @case (CustomerAuditEntryPropertyChangeType.SiteUnassignment) {
                                                        <div>
                                                            {{ 'users.history.siteUnassignment' | translate }}
                                                            <i>{{ audit['siteName' + crtLang.toUpperCase()] }}</i>
                                                        </div>
                                                    }
                                                }
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                }
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="btn-bar">
            <button class="btn btn-outline-secondary" type="button"
                    (click)="back()"
                    translate="common.back">
            </button>

            @if (editingMyProfile) {
                <button class="btn btn-outline-secondary" type="button"
                        (click)="resetPassword()" translate="users.form.actions.changePassword">
                </button>
            }

            <button type="submit" class="btn btn-primary"
                    [disabled]="customerForm.invalid || ((customerId || editingMyProfile) && customerForm.pristine)"
                    (click)="save()">
                {{ ((customerId || editingMyProfile) ? 'common.save' : 'common.create') | translate }}
            </button>
        </div>
    </form>
</div>
